<app-accordion-group>
  @for (item of treesToRemove(); let i = $index; track i) {
    <app-accordion-item
      [name]="($index + 1) + '. ' + (item?.species | capitalizeFirstLetter) + '. Wysokość opłaty: ' + (item?.removalFee | currency)"
      [disabled]='false'>
      <div class="row">
        <div class='col-md-4 d-flex align-items-center'>
          <app-label label='Obręb:'>
            {{ item?.district || '-' }}
          </app-label>
        </div>
        <div class='col-md-4 d-flex align-items-center'>
          <app-label label='Działka numer:'>
            {{ item?.registryNumber || '-' }}
          </app-label>
        </div>
        <div class='col-md-4 d-flex align-items-center'>
          <app-label [label]='(item?.objectType | treeToRemoveTrunkCircumference130Label) + ":"'>
            {{ item?.trunkCircumference130 || '-' }}
          </app-label>
        </div>
        <div class='col-12 d-flex align-items-center'>
          <app-label label='Przeznaczenie terenu:'>
            {{ item?.landDesignation || '-' }}
          </app-label>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex align-items-center">
          <app-label label="Przyczyna usunięcia:">
            @if (item?.removalReasons | treeRemovalReason : reasons() : item?.otherRemovalReason; as reasons) {
              {{ reasons }}
            }
          </app-label>
        </div>
        <div class='col-12 d-flex align-items-center'>
          <app-label label='Uzasadnienie usunięcia:'>
            {{ item?.removalJustification || '-' }}
          </app-label>
        </div>
      </div>
      <div slot="action" *ngIf="showActions()">
        <button
          [disabled]="!canEdit()"
          title="Edytuj"
          class='btn btn-secondary icon-btn'
          type="button"
          (click)="onEdit.emit({ v: item, i }); $event.preventDefault(); $event.stopPropagation()">
          <i class='fa fa-pencil-alt'></i>
        </button>
        &nbsp;
        <button
          title="Usuń z listy"
          class="btn btn-red-secondary icon-btn"
          type="button"
          [disabled]="!canEdit()"
          (click)="onRemove.emit(i); $event.preventDefault(); $event.stopPropagation()">
          <i class="fa fa-trash-alt" aria-hidden="true"></i>
        </button>
      </div>
    </app-accordion-item>
  }
</app-accordion-group>
@if (!treesToRemove().length) {
  <div class="row">
    <div class="col-12">
      <app-alert type="info" [closable]="false"><strong>Brak dodanych drzew lub krzewów</strong></app-alert>
    </div>
  </div>
}
